import React, { useContext } from 'react';

import PersonContext from '@/pages/Person/PersonContext';
import DataList, { DataRow } from '@/ui/components/DataList';

const PersonDemographics = () => {
  const { person } = useContext(PersonContext);
  const { demographics } = person;

  if (!demographics) {
    return null;
  }

  return (
    <DataList>
      {demographics.race_ethnicity && (
        <DataRow
          sensitive
          label="Race/Ethnicity"
          content={demographics.race_ethnicity.join(', ')}
        />
      )}
      {demographics.race_ethnicity_other && (
        <DataRow
          sensitive
          label="Race/Ethnicity Other"
          content={demographics.race_ethnicity_other}
        />
      )}
      {demographics.hispanic_origin !== null && (
        <DataRow
          sensitive
          label="Hispanic Origin"
          content={demographics.hispanic_origin ? 'Yes' : 'No'}
        />
      )}
      {demographics.housing_status && (
        <DataRow sensitive label="Housing Status" content={demographics.housing_status} />
      )}
      {demographics.housing_status_other && (
        <DataRow
          sensitive
          label="Housing Status Other"
          content={demographics.housing_status_other}
        />
      )}
      {demographics.employment_status && (
        <DataRow sensitive label="Employment Status" content={demographics.employment_status} />
      )}
      {demographics.gender && <DataRow sensitive label="Gender" content={demographics.gender} />}
      {demographics.transgender && (
        <DataRow sensitive label="Transgender" content={demographics.transgender} />
      )}
      {demographics.sexual_orientation && (
        <DataRow sensitive label="Sexual Orientation" content={demographics.sexual_orientation} />
      )}
      {demographics.education && (
        <DataRow sensitive label="Education" content={demographics.education} />
      )}
      {demographics.resides_with_other_drug_users !== null && (
        <DataRow
          sensitive
          label="Resides with Other Drug Users"
          content={demographics.resides_with_other_drug_users ? 'Yes' : 'No'}
        />
      )}
      {demographics.relationship_status && (
        <DataRow sensitive label="Relationship Status" content={demographics.relationship_status} />
      )}
      {demographics.asam_score !== null && (
        <DataRow sensitive label="ASAM Score" content={demographics.asam_score} />
      )}
      {demographics.nps_score !== null && (
        <DataRow sensitive label="NPS Score" content={demographics.nps_score} />
      )}
      {demographics.goal_description && (
        <DataRow sensitive label="Goal Description" content={demographics.goal_description} />
      )}
      {demographics.experience_in_treatment && (
        <DataRow
          sensitive
          label="Experience in Treatment"
          content={demographics.experience_in_treatment.join(', ')}
        />
      )}
      {demographics.opiod_use_oxy && (
        <DataRow sensitive label="Opioid Use (Oxy)" content={demographics.opiod_use_oxy} />
      )}
      {demographics.opiod_use_heroin_fentanyl && (
        <DataRow
          sensitive
          label="Opioid Use (Heroin/Fentanyl)"
          content={demographics.opiod_use_heroin_fentanyl}
        />
      )}
    </DataList>
  );
};

export default React.memo(PersonDemographics);
